import React from "react";
import { Link } from "react-router-dom";
import LoginForm from "../components/LoginForm";
import { AuthLayout } from "../components/auth/AuthLayout";

export default function LoginPage() {
  return (
    <AuthLayout
      title="Bienvenido de nuevo"
      subtitle="Accede a tu panel financiero familiar y revisa el balance del mes."
      footer={
        <p className="section-subtitle">
          ¿Aún no tienes cuenta? <Link to="/auth/register">Crea tu cuenta gratis</Link>
        </p>
      }
    >
      <LoginForm />
    </AuthLayout>
  );
}
